import {
  AlertDialog,
  AlertDialogContent,
} from "@/components/ui/alert-dialog/alert-dialog";
import { useTodoViewModal } from "./hooks/use-todo-view-modal";
import { cn } from "@/lib/utils";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion/accordion";
import { Separator } from "@/components/ui/separator/separator";
import { MdClose } from "react-icons/md";
import { format } from "date-fns";

export const TodoViewModal = () => {
  const { open, onOpenChange, setTodo, todo } = useTodoViewModal();

  const colors: {
    [key: string]: string;
  } = {
    Pending: "text-neutral-500",
    Started: "text-yellow-500",
    "Update Required": "text-blue-500",
    Testing: "text-emerald-400",
    Finished: "text-green-500",
  };

  return (
    <>
      <AlertDialog open={open} onOpenChange={onOpenChange}>
        <AlertDialogContent className="p-0 max-w-7xl">
          <div>
            <div className="border-b px-3 py-1 flex items-center justify-end">
              <div className="relative">
                <button
                  type="button"
                  className="p-1 rounded-md transition-all duration-300 hover:bg-accent"
                  onClick={() => {
                    onOpenChange(false);
                    setTodo(null);
                  }}
                >
                  <MdClose className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="flex">
              <div className="flex-[0.6] p-5 space-y-4">
                <h1 className="text-3xl font-semibold">{todo?.title}</h1>

                <p className="text-base">{todo?.description}</p>

                <Separator className="my-3" />

                <div className="flex flex-col">
                  <h3 className="text-lg font-medium">Subtasks</h3>

                  <Accordion type="single" collapsible>
                    {todo?.tasks?.map((task, index) => {
                      return (
                        <AccordionItem value={`item-${index + 1}`} className="">
                          <AccordionTrigger className="truncate tracking-normal">
                            {task?.description}
                          </AccordionTrigger>
                          <AccordionContent>
                            <div className="flex flex-col">
                              <div className="flex items-center justify-between">
                                <p>{task?.description}</p>
                              </div>

                              <p
                                className={cn(
                                  colors[task?.status as string],
                                  "font-medium"
                                )}
                              >
                                {task?.status}
                              </p>

                              {task?.files && task?.files?.length > 0 && (
                                <div className="flex flex-col gap-2 mt-4">
                                  {task?.files?.map((file, index) => {
                                    return (
                                      <div className="border rounded-md border-dashed transition-all duration-300 hover:bg-accent">
                                        <a
                                          href={file}
                                          target="_blank"
                                          className="px-3 py-1.5 w-full inline-block rounded-md"
                                        >
                                          Attachment {index + 1}
                                        </a>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </AccordionContent>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </div>
              </div>

              <div className="flex-[0.4] border-l p-5 space-y-4">
                <div className="flex flex-col gap-5">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-1">
                      <p>Status : </p>
                      <p
                        className={cn(
                          colors[todo?.column as string],
                          "font-medium"
                        )}
                      >
                        {todo?.column}
                      </p>
                    </div>
                  </div>

                  {todo?.deadline && (
                    <div className="flex items-center gap-1">
                      <p>Deadline : </p>
                      <p>{format(new Date(todo?.deadline as string), "PPP")}</p>
                    </div>
                  )}

                  {todo?.files && todo?.files?.length > 0 && (
                    <div className="flex flex-col gap-3 mt-4">
                      {todo?.files?.map((file, index) => {
                        return (
                          <div className="border rounded-md border-dashed transition-all duration-300 hover:bg-accent">
                            <a
                              href={file}
                              target="_blank"
                              className="px-3 py-1.5 w-full inline-block rounded-md"
                            >
                              Attachment {index + 1}
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
